import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Tab,
  TabList,
  Tabs,
  Text,
} from "@chakra-ui/react";
import BoxShadowContainer from "components/UIComponents/BoxShadowContainer";
import { amountOptions } from "../amountOptions";

const PaymentProccessComponent = ({
  createInvoice,
  amount,
  setAmount,
  network,
  currency,
}) => {
  const handleChange = (event) => {
    const { value } = event.target;
    setAmount(parseFloat(value.trim() || 0));
  };

  const allFieldsFullfiled = network && currency && amount > 0;

  return (
    <BoxShadowContainer className="payment-process-block">
      <Heading size="lg" mb={5}>
        Amount
      </Heading>
      <Flex flexDirection="column" justifyContent="space-between">
        <Box>
          <Tabs variant="solid-rounded" defaultIndex={-1}>
            <TabList>
              {amountOptions.map((option) => (
                <Tab
                  key={option.id}
                  _selected={{ color: "brand.fg", bg: "brand.solid" }}
                  onClick={() => setAmount(option.amount)}
                >
                  <Text>$ {option.amount}</Text>
                </Tab>
              ))}
            </TabList>
          </Tabs>
          <Divider mt={5} />
          <Box mt={5}>
            <InputGroup>
              <Input
                placeholder="Enter amount"
                _placeholder={{ opacity: 1, color: "text.disabled" }}
                type="number"
                onChange={handleChange}
                value={amount || ""}
                fontSize={20}
                size="lg"
              />
              <InputRightElement height="100%">$</InputRightElement>
            </InputGroup>
          </Box>
        </Box>
        <Button
          mt={5}
          colorScheme="green"
          onClick={() => (allFieldsFullfiled ? createInvoice() : () => {})}
          isDisabled={!allFieldsFullfiled}
        >
          Create bill
        </Button>
      </Flex>
    </BoxShadowContainer>
  );
};

export default PaymentProccessComponent;